import { NotificationInbox } from 'components/notification-inbox';

export default function NotificationInboxScreen() {
  return <NotificationInbox />;
}
